/* import __COLOCATED_TEMPLATE__ from './phone-number-input.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { AsYouType, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';
const COUNTRY_CODE_TO_FLAG = {
  AU: 'australia',
  CA: 'canada',
  ES: 'spain',
  FR: 'france',
  GB: 'uk',
  GG: 'uk',
  JP: 'japan',
  IE: 'ireland',
  US: 'usa'
};
const DEFAULT_COUNTRY_CODE = 'US';
const NO_COUNTRY_CODE = 'none';
const PHONE_INPUT_IGNORED_KEYS = ['Tab', 'Enter', 'Escape', 'End', 'Home', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Shift'];
let PhoneNumberInputComponent = (_class = class PhoneNumberInputComponent extends Component {
  /**
   * Initialization
   */
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "usOverCa", true);
    // show the US label and flag, not CA label and flag
    _defineProperty(this, "countryCode", void 0);
    _defineProperty(this, "preferredCountryCodes", void 0);
    _initializerDefineProperty(this, "countryList", _descriptor2, this);
    _initializerDefineProperty(this, "selectedCountry", _descriptor3, this);
    _defineProperty(this, "phoneNumberElement", void 0);
    _defineProperty(this, "ignoreUpdate", false);
    this.countryCode = String(this.args.countryCode || DEFAULT_COUNTRY_CODE).toUpperCase();
    if (this.args.countryCode === 'US') {
      this.usOverCa = true;
    } else if (this.args.countryCode === 'CA') {
      this.usOverCa = false;
    } else if (this.args.usOverCa === undefined) {
      if (this.countryCode === 'US') {
        this.usOverCa = true;
      } else if (this.countryCode === 'CA') {
        this.usOverCa = false;
      }
    } else {
      this.usOverCa = this.args.usOverCa;
      if (this.usOverCa && this.countryCode === 'CA') {
        this.countryCode = 'US';
      } else if (!this.usOverCa && this.countryCode === 'US') {
        this.countryCode = 'CA';
      }
    }
    // preferredCountryCodes are the countries shown in the country code select
    this.preferredCountryCodes = Object.keys(this.args.countryCodeToT);
    this.updateCountries();
  }
  initializePhoneNumber(event) {
    const input = event.detail.input;
    this.phoneNumberElement = input;
    input.setAttribute('autocomplete', 'tel-national');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'false');
    input.setAttribute('aria-label', this.intl.t(this.args.tPhoneNumber));

    // bind events
    const that = this;
    const boundKeyDown = this.keyDown.bind(this);
    const boundPaste = this.paste.bind(this);
    const boundUpdate = this.updatePhoneNumber.bind(this);
    input.onblur = () => {
      if (!that.ignoreUpdate && that.lastValue !== that.value) {
        boundUpdate();
      }
    };
    input.onchange = () => {
      if (!that.ignoreUpdate && that.lastValue !== that.value) {
        boundUpdate();
      }
    };
    input.onkeydown = event => {
      that.ignoreUpdate = true;
      boundKeyDown(event);
      that.ignoreUpdate = false;
    };
    input.onpaste = event => {
      that.ignoreUpdate = true;
      boundPaste(event);
      that.ignoreUpdate = false;
    };
    const phoneNumber = this.args.phoneNumber || '';
    if (phoneNumber !== '') {
      this.setPhoneNumber(phoneNumber, phoneNumber.length);
      this.phoneNumberElement.dispatchEvent(new Event('input'));
    }
    this.updatePhoneNumber();
    if (this.focusOnLoad) {
      input.focus();
    }
    if (this.args.setPhoneInput) {
      this.args.setPhoneInput(this.phoneNumberElement);
    }
  }

  /**
   * Accessing
   */
  get errorId() {
    if (this.invalid) {
      return this.args.errorId;
    } else {
      return undefined;
    }
  }
  get focusOnLoad() {
    return this.args.focusOnLoad || false;
  }
  get invalid() {
    return this.args.invalid || false;
  }
  get isOtherCountry() {
    return !this.isPreferredCountry;
  }
  get isPreferredCountry() {
    return this.preferredCountryCodes.includes(this.countryCode);
  }
  get noCountryCode() {
    return NO_COUNTRY_CODE;
  }
  get selectionEnd() {
    return this.phoneNumberElement ? this.phoneNumberElement.selectionEnd : this.selectionEnd;
  }
  set selectionEnd(index) {
    if (this.phoneNumberElement) {
      this.phoneNumberElement.selectionEnd = index;
    }
  }
  get selectionStart() {
    return this.phoneNumberElement ? this.phoneNumberElement.selectionStart : 0;
  }
  set selectionStart(index) {
    if (this.phoneNumberElement) {
      this.phoneNumberElement.selectionStart = index;
    }
  }
  get tCountryCode() {
    return this.args.tCountryCode;
  }
  get tPhoneNumber() {
    return this.args.tPhoneNumber;
  }
  get value() {
    return this.phoneNumberElement ? this.phoneNumberElement.value : '';
  }
  set value(string) {
    if (this.phoneNumberElement === undefined) return;
    this.phoneNumberElement.value = string === undefined || string === null ? '' : string;
    const parsedNumber = this.countryCode === NO_COUNTRY_CODE ? parsePhoneNumberFromString('+' + this.value) : parsePhoneNumberFromString(this.value, this.countryCode);
    this.valid = parsedNumber === undefined ? false : parsedNumber.isValid();
    if (this.valid && this.args.onValid) {
      this.args.onValid({
        country: parsedNumber.country,
        national: parsedNumber.formatNational(),
        number: parsedNumber.number
      });
      if (this.preferredCountryCodes.includes(parsedNumber.country)) {
        this.setCountryCode(parsedNumber.country);
      }
    } else if (!this.valid && this.args.onInvalid) {
      this.args.onInvalid();
    }
    // ARIA support
    if (this.invalid) {
      this.phoneNumberElement.setAttribute('aria-invalid', 'true');
    } else {
      this.phoneNumberElement.removeAttribute('aria-invalid');
    }
    const errorId = this.errorId;
    if (errorId === undefined) {
      this.phoneNumberElement.removeAttribute('aria-describedBy');
    } else {
      this.phoneNumberElement.setAttribute('aria-describedBy', errorId);
    }
  }

  /**
   * Event Handling
   */
  keyDown(event) {
    const key = event.key;
    const keyCode = event.keyCode;
    const value = this.value;
    const start = this.selectionStart;
    const end = this.selectionEnd;
    const before = (value.slice(0, start).match(/\d/g) || []).join('');
    const after = (value.slice(end).match(/\d/g) || []).join('');

    // ignore international keyboard composing input
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
    if (event.isComposing || keyCode === 229) {
      this.setPhoneNumber(value, start);
      this.phoneNumberElement.dispatchEvent(new Event('input'));
      return;
    }
    if (key === 'Enter' && this.args.onEnter) {
      this.args.onEnter();
    } else if (event.ctrlKey || event.metaKey || PHONE_INPUT_IGNORED_KEYS.includes(key)) {
      // fall through
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (key === 'Backspace' || key === 'Delete') {
      let beforeSelection = before;
      let afterSelection = after;
      if (start !== end) {
        // just delete the highlighted portion
      } else if (key === 'Backspace' && before.length > 0) {
        beforeSelection = before.slice(0, before.length - 1);
      } else if (key === 'Delete' && after.length > 0) {
        afterSelection = after.slice(1);
      }
      this.setPhoneNumber(beforeSelection + afterSelection, beforeSelection.length);
    } else if (/^\d$/.test(key)) {
      this.setPhoneNumber(value.slice(0, start) + key + value.slice(end), start + 1);
    } else if (key === '+' && !this.isOtherCountry && before.length === 0) {
      this.setCountryCode(NO_COUNTRY_CODE);
      this.setPhoneNumber((value.slice(end).match(/\d/g) || []).join(''), 0);
    } else if (start !== end) {
      this.setPhoneNumber(value.slice(0, start) + value.slice(end), start);
    } else {
      this.setPhoneNumber(value, start);
    }
    this.phoneNumberElement.dispatchEvent(new Event('input'));
  }
  paste(event) {
    let clipboardData = event.clipboardData;
    if (clipboardData === undefined) {
      clipboardData = window.clipboardData;
    }
    let clipboardText = '';
    if (clipboardData !== undefined) {
      clipboardText = clipboardData.getData('Text');
    }
    const value = this.value;
    let start = this.selectionStart;
    const before = value.slice(0, start) + clipboardText;
    const newValue = [];
    for (const char of before) {
      if (char === '+' && newValue.length === 0) {
        newValue.push(char);
      } else if (/^\d$/.test(char)) {
        newValue.push(char);
      }
    }
    start = newValue.length;
    for (const char of value.slice(this.selectionEnd)) {
      if (char === '+' && newValue.length === 0) {
        newValue.push(char);
      } else if (/^\d$/.test(char)) {
        newValue.push(char);
      }
    }
    this.setPhoneNumber(newValue.join(''), start);
    event.preventDefault();
    event.stopPropagation();
    this.phoneNumberElement.dispatchEvent(new Event('input'));
  }
  selectCountryCode(event) {
    const newCode = event.detail.value;
    if (newCode === this.countryCode) {
      return;
    }
    this.countryCode = newCode;
    this.updateCountries();
    this.updatePhoneNumber();
  }
  setCountryCode(newCode) {
    if (newCode === 'GG') {
      // Guernsey can be treated the same as Great Britain
      newCode = 'GB';
    }
    if (newCode === this.countryCode) {
      return;
    }
    this.countryCode = newCode;
    this.updateCountries();
  }
  setPhoneNumber(string, position) {
    let start = (string.slice(0, position).match(/\d/g) || []).length;
    let newValue = (string.match(/\d/g) || []).join('');
    if (this.isOtherCountry) {
      const ayt = new AsYouType();
      newValue = ayt.input('+' + newValue);
      const countryCode = ayt.country === undefined ? NO_COUNTRY_CODE : ayt.country;
      this.setCountryCode(countryCode);
      if (this.preferredCountryCodes.includes(countryCode)) {
        const prefixLength = getCountryCallingCode(countryCode).length;
        start -= prefixLength;
        newValue = (string.match(/\d/g) || []).join('').slice(prefixLength);
        newValue = new AsYouType(this.countryCode).input(newValue);
      } else {
        newValue = newValue.slice(1);
      }
    } else {
      newValue = new AsYouType(this.countryCode).input(newValue);
    }
    this.value = newValue;
    // set position
    for (let newStart = 0; newStart < newValue.length; newStart++) {
      if (/\d/.test(newValue.slice(newStart, newStart + 1))) {
        if (start === 0) {
          this.phoneNumberElement.setSelectionRange(newStart, newStart);
          return;
        } else {
          start--;
        }
      }
    }
    this.phoneNumberElement.setSelectionRange(newValue.length, newValue.length);
  }
  updateCountries() {
    const countries = [];
    let isOtherCountry = true;
    for (const [code, t] of Object.entries(this.args.countryCodeToT)) {
      const prefix = getCountryCallingCode(code);
      const country = {
        code,
        prefix,
        t
      };
      const flag = COUNTRY_CODE_TO_FLAG[code];
      if (flag !== undefined) {
        country.flag = flag;
      }
      if (code === 'US') {
        if (this.countryCode !== 'CA' && (this.usOverCa || this.countryCode === 'US')) {
          countries.push(country);
        }
      } else if (code === 'CA') {
        if (this.countryCode !== 'US' && (!this.usOverCa || this.countryCode === 'CA')) {
          countries.push(country);
        }
      } else {
        countries.push(country);
      }
      if (this.countryCode === code) {
        isOtherCountry = false;
      }
    }
    if (this.countryCode === NO_COUNTRY_CODE) {
      isOtherCountry = false;
    }
    // add other country
    if (isOtherCountry) {
      countries.push({
        code: this.countryCode,
        label: this.countryCode,
        prefix: ''
      });
    } else {
      countries.push({
        code: NO_COUNTRY_CODE,
        prefix: '',
        t: this.args.tOtherCountry
      });
    }
    this.countryList = countries;
    later(() => {
      this.selectedCountry = this.countryCode;
      if (this.args.onCountryCodeSelected) {
        this.args.onCountryCodeSelected(this.countryCode);
      }
    });
  }
  updatePhoneNumber() {
    this.ignoreUpdate = true;
    let value = this.value;
    let position = this.selectionStart;
    if (position === undefined || position === null) {
      position = value.length;
    }
    this.setPhoneNumber(value, position);
    later(() => this.ignoreUpdate = false, 1);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "countryList", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedCountry", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "initializePhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializePhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCountryCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCountryCode"), _class.prototype), _class);
export { PhoneNumberInputComponent as default };